import * as Config from './config'
import Gradables from './gradables'
import * as Attendances from './attendances'

export default {
  Attendances,
  Config,
  Gradables,
}
